// re-push trigger
import React, { useEffect, useState } from 'react';
import BackButton from '../components/BackButton';
import {
  Box,
  Typography,
  TextField,
  Button,
  Alert,
  MenuItem,
  Card,
  CardContent
} from '@mui/material';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';

const EditQuestionPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [question, setQuestion] = useState(null);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    const fetchQuestion = async () => {
      const token = localStorage.getItem('teacherToken');
      try {
        const response = await axios.get(`https://education-backend.liara.run/api/question/${id}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
          console.log('✅ پاسخ API:', response.data); 
        setQuestion(response.data);
      } catch (err) {
        setError('❌ دریافت اطلاعات سؤال ناموفق بود.');
      }
    };
    fetchQuestion();
  }, [id]);

  const handleUpdate = async () => {
    const token = localStorage.getItem('teacherToken');
    try {
      await axios.put(`https://education-backend.liara.run/api/question/update/${id}`, question, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setSuccess('✅ سؤال با موفقیت ویرایش شد.');
    } catch (err) {
      setError('❌ خطا در ویرایش سؤال.');
    }
  };

  if (!question) return <Typography sx={{ padding: '2rem' }}>در حال بارگذاری...</Typography>;

  return (
    <Box sx={{ padding: '2rem', maxWidth: '600px', margin: 'auto' }}  dir="rtl">
      <header style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <BackButton toFallback="/dashboard" />
        </header>
      <Card>
        <CardContent>
          <Typography variant="h5" gutterBottom>ویرایش سؤال 🛠️</Typography>

          {error && <Alert severity="error" sx={{ marginBottom: '1rem' }}>{error}</Alert>}
          {success && <Alert severity="success" sx={{ marginBottom: '1rem' }}>{success}</Alert>}

          <TextField
            label="متن سؤال"
            value={question.content}
            onChange={(e) => setQuestion({ ...question, content: e.target.value })}
            fullWidth
            multiline
            sx={{ marginBottom: '1rem' }}
          />

          {['A', 'B', 'C', 'D'].map((opt) => (
            <TextField
              key={opt}
              label={`گزینه ${opt}`}
              value={question[`option${opt}`]}
              onChange={(e) => setQuestion({ ...question, [`option${opt}`]: e.target.value })}
              fullWidth
              sx={{ marginBottom: '1rem' }}
            />
          ))}

          <TextField
            label="گزینه درست"
            select
            value={question.correctOption}
            onChange={(e) => setQuestion({ ...question, correctOption: e.target.value })}
            fullWidth
            sx={{ marginBottom: '1rem' }}
          >
            {['A', 'B', 'C', 'D'].map((opt) => (
              <MenuItem key={opt} value={opt}>{opt}</MenuItem>
            ))}
          </TextField>

          <TextField
            label="شناسه درس"
            value={question.lessonId}
            onChange={(e) => setQuestion({ ...question, lessonId: e.target.value })}
            fullWidth
            sx={{ marginBottom: '1rem' }}
          />
          <TextField
              label="درس مرتبط"
              value={question.lessonTitle || `شناسه: ${question.lessonId}`}
              fullWidth
              disabled
              sx={{ marginBottom: '1rem' }}
          />
          

          <TextField
            label="تاریخ انقضا"
            type="date"
            value={question.expirationDate?.slice(0, 10)}
            onChange={(e) => setQuestion({ ...question, expirationDate: e.target.value })}
            fullWidth
            InputLabelProps={{ shrink: true }}
            sx={{ marginBottom: '1rem' }}
          />

          <Button variant="contained" fullWidth onClick={handleUpdate}>
            ثبت تغییرات
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};

export default EditQuestionPage;
